module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLogin) ? _c('div', {
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      backgroundImage: 'url(' + _vm.headImg + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "nick-name"
  }, [_vm._v("@" + _vm._s(_vm.nickName))])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.handlePreviewImage
    }
  }, [_vm._v("预览并保存")]), _vm._v(" "), _c('canvas', {
    staticStyle: {
      "width": "100%",
      "height": "1269rpx",
      "background": "#fff",
      "position": "fixed",
      "top": "-10000px"
    },
    attrs: {
      "id": "J_canvas"
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cde1ef0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/boss-image/index.vue
// module id = 353
// module chunks = 0